<template>
  <div class="row">
    <div class="col-lg-6">
      <div v-if="!user.isValidated" class="alert alert-warning" role="alert">
        Votre compte est en attente de validation. Vous pourrez utiliser l'API une fois la validation effectuée.
      </div>

      <div class="card p-3">
        <h3>Envoyer via l’API</h3>

        <p>Pour envoyer des Push SMS de manière programmatique, il faut soumettre une requête en <code>JSON</code> à notre API avec les paramètres suivants&nbsp;:</p>

        <ul>
          <li><p><code>telephone</code>&nbsp;: le numéro de téléphone du destinataire (format +33, 0033 ou 06/07)</p></li>
          <li><p><code>text</code>&nbsp;: le texte du message (les SMS ne peuvent contenir des caractères en dehors de la <a href="https://en.wikipedia.org/wiki/GSM_03.38" target="_blank">table GSM</a>)</p></li>
          <li><p><code>senderName</code>&nbsp;: permet de définir le nom de l’expéditeur (commence par une lettre, ne contient pas de caractères spéciaux et ne peut faire plus de 11 caractères) [optionnel]</p></li>
        </ul>

        <h4>Endoint API</h4>

        <p>L’API reçoit les requêtes en <code>HTTP POST</code> au endpoint suivant&nbsp;:</p>

        <div class="row">
          <div class="col-10">
            <input type="text" ref="endpoint" :value="endpoint" class="form-control" readonly>
          </div>

          <div class="col-2 pl-0">
            <button @click="copyEndpoint" class="btn btn-block" :class="endpointButtonType">{{ endpointButtonText }}</button>
          </div>
        </div>

        <p class="mt-1">L'API retourne un JSON avec l'id du SMS envoyé, ex <code>{ id: 76543 }</code></p>

        <h4 class="mt-4">Authentification</h4>

        <p>
          L’authentification s’effectue par l’envoi d’un bearer token, vous devez donc l’inclure avec chacune de vos requêtes.
          <br>
          Ce token est actualisé dès que vous modifiez le mot de passe du compte.
        </p>

        <div class="row">
          <div class="col-10">
            <input type="text" ref="token" :value="token" class="form-control" readonly>
          </div>

          <div class="col-2 pl-0">
            <button @click="copyToken" class="btn btn-block" :class="tokenButtonType">{{ tokenButtonText }}</button>
          </div>
        </div>
      </div>
    </div>

    <div class="col-lg-6">
      <div class="card p-3">
        <h3>URL de notification</h3>

        <p>Si vous la définissez, cette url sera notifiée dès que le statut de votre SMS change. L’url reçoit en <code>HTTP POST</code> les paramètres suivants&nbsp;:</p>

        <ul>
          <li><p><code>smsId</code>&nbsp;: il s’agit de l’id retourné en réponse par la Push API</p></li>
          <li><p><code>status</code>&nbsp;: le code de status du SMS (0 = en attente / 1 = reçu / 2 = NPAI / 3 = erreur)</p></li>
        </ul>

        <div class="row">
          <div class="col-10">
            <input type="text" v-model="newNotifyUrl" :placeholder="notifyUrl" class="form-control">
          </div>

          <div class="col-2 pl-0">
            <button @click="updateNotifyUrl" class="btn btn-block" :class="notifyButtonType">{{ notifyButtonText }}</button>
          </div>
        </div>
    </div>
    </div>
  </div>
</template>

<script>
import Axios from 'axios';
import store from '@/store';
import { mapActions, mapGetters } from 'vuex';

export default {
  beforeRouteEnter(to, from, next) {
    store.dispatch('auth/getUser').then(next);
  },

  data() {
    return {
      endpoint: `${Axios.defaults.baseURL}/push/`,
      token: this.$store.state.auth.token,
      endpointButtonType: 'btn-primary',
      endpointButtonText: 'Copier',
      tokenButtonType: 'btn-primary',
      tokenButtonText: 'Copier',
      notifyButtonType: 'btn-primary',
      notifyButtonText: 'Enregistrer',
      newNotifyUrl: null
    };
  },

  computed: {
    ...mapGetters({
      user: 'auth/user'
    }),
    notifyUrl() {
      return this.$store.state.auth.user.notifyUrl || 'https://example.com/notify-sms-status/';
    }
  },

  methods: {
    ...mapActions({
      updateAccount: 'auth/updateAccount'
    }),

    copyEndpoint() {
      this.$refs.endpoint.select();

      if (document.execCommand('copy')) {
        this.endpointButtonType = 'btn-success';
        this.endpointButtonText = 'Copié';

        setTimeout(() => {
          this.endpointButtonType = 'btn-primary';
          this.endpointButtonText = 'Copier';
        }, 5000);
      }
    },

    copyToken() {
      this.$refs.token.select();

      if (document.execCommand('copy')) {
        this.tokenButtonType = 'btn-success';
        this.tokenButtonText = 'Copié';

        setTimeout(() => {
          this.tokenButtonType = 'btn-primary';
          this.tokenButtonText = 'Copier';
        }, 5000);
      }
    },

    updateNotifyUrl() {
      this.updateAccount({ notifyUrl: this.newNotifyUrl })
        .then(() => {
          this.notifyButtonType = 'btn-success';
          this.notifyButtonText = 'Enregistré';

          setTimeout(() => {
            this.notifyButtonType = 'btn-primary';
            this.notifyButtonText = 'Enregistrer';
          }, 5000);
        })
        .catch(error => this.$eventBus.$emit('fetch-data-error', error));
    }
  }
};
</script>
